import { useEffect, useState } from "react";

export type ClipTheme = "dark" | "light";

const STORAGE_KEY = "booker-clips-theme";
const THEME_EVENT = "nova-gang-theme-change";

export function useClipTheme() {
  const [theme, setTheme] = useState<ClipTheme>(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === "light" ? "light" : "dark";
    } catch {
      return "dark";
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // The selected theme still works when browser storage is unavailable.
    }
    window.dispatchEvent(new CustomEvent<ClipTheme>(THEME_EVENT, { detail: theme }));
  }, [theme]);

  useEffect(() => {
    const syncTheme = (event: Event) => {
      const nextTheme = (event as CustomEvent<ClipTheme>).detail;
      if (nextTheme === "dark" || nextTheme === "light") setTheme(nextTheme);
    };
    window.addEventListener(THEME_EVENT, syncTheme);
    return () => window.removeEventListener(THEME_EVENT, syncTheme);
  }, []);

  const toggleTheme = () => setTheme((current) => current === "dark" ? "light" : "dark");
  return { theme, toggleTheme };
}
